import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import PopperPopupState from './PopperPopupState';
import ClientProvider from './client';
export default createDemo(import.meta.url, PopperPopupState, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/popper/demos/popup-state/PopperPopupState.tsx",
    "fileName": "PopperPopupState.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Typography from '@mui/material/Typography';\nimport Button from '@mui/material/Button';\nimport Popper from '@mui/material/Popper';\nimport PopupState, { bindToggle, bindPopper } from 'material-ui-popup-state';\nimport Fade from '@mui/material/Fade';\nimport Paper from '@mui/material/Paper';\n\nexport default function PopperPopupState() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <PopupState variant=\"popper\" popupId=\"demo-popup-popper\">\n      {(popupState) => (\n        <div>\n          <Button variant=\"contained\" {...bindToggle(popupState)}>\n            Toggle Popper\n          </Button>\n          <Popper {...bindPopper(popupState)} transition>\n            {({ TransitionProps }) => (\n              <Fade {...TransitionProps} timeout={350}>\n                <Paper>\n                  <Typography sx={{ p: 2 }}>The content of the Popper.</Typography>\n                </Paper>\n              </Fade>\n            )}\n          </Popper>\n        </div>\n      )}\n    </PopupState>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 29,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Typography from '@mui/material/Typography';\nimport Button from '@mui/material/Button';\nimport Popper from '@mui/material/Popper';\nimport PopupState, { bindToggle, bindPopper } from 'material-ui-popup-state';\nimport Fade from '@mui/material/Fade';\nimport Paper from '@mui/material/Paper';\n\nexport default function PopperPopupState() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <PopupState variant=\"popper\" popupId=\"demo-popup-popper\">\n      {(popupState) => (\n        <div>\n          <Button variant=\"contained\" {...bindToggle(popupState)}>\n            Toggle Popper\n          </Button>\n          <Popper {...bindPopper(popupState)} transition>\n            {({ TransitionProps }) => (\n              <Fade {...TransitionProps} timeout={350}>\n                <Paper>\n                  <Typography sx={{ p: 2 }}>The content of the Popper.</Typography>\n                </Paper>\n              </Fade>\n            )}\n          </Popper>\n        </div>\n      )}\n    </PopupState>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 29,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Typography",
      "@mui/material/Button",
      "@mui/material/Popper",
      "material-ui-popup-state",
      "@mui/material/Fade",
      "@mui/material/Paper"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
